<template>
  <section>
    <b-row >
      <b-col class="box-effect linear"
        >
            <b-card 
              >   
                <template v-slot:header >
                  <div class="header-card">
                    Agregar Servicios
                  </div> 
                </template>              
                <b-nav tabs>
                  <b-nav-item :active="active===0" @click="active=0">Agregar Servicios al Afiliado</b-nav-item>
                </b-nav> 
                <div  style="border:1px solid; border-top:none;border-color: #dee2e6 ">
                  <div v-if="active===0">
                    <b-row  align-v="center"> 
                      <sw-searchs
                        :md="5"
                        :lg="5"
                        style="margin-top:20px"
                        label='Seleccionar afiliado'
                        list='datos_afiliado'
                        filterCampos="documento"
                        :filter="{campo: 'id_list_estado', value: 1}"
                        @input="watchAfiliado"
                        >
                      </sw-searchs> 
                      <b-col>
                        <b-button @click="searchSw.value=''" style="margin-top:28px" size="sm">Limpiar</b-button>
                      </b-col> 
                    </b-row> 
                    <sw-loading v-if="searchSw.value!='' && dataForm[namePath].servicios_activos.length===0"></sw-loading>
                    <b-row v-if="searchSw.value!='' && dataForm[namePath].servicios_activos.length>0">
                      <b-col :md="3">
                        <h5 class="title-form">Servicios Activos</h5>
                        <table>                         
                          <tbody>
                            <tr v-for="(items,index) in dataForm[namePath].servicios_activos" :key="'activos_servicios'+index" v-show="items.name!='Administración'">
                              <td style="padding-top: 10px;">{{items.name}} <span v-if="items.name_list!=null">{{gettersDatalist(items.name_list,items.id_list)[0].name}}</span></td>
                            </tr>
                          </tbody>
                        </table>
                      </b-col>
                      <b-col>
                        <h5 class="title-form">Servicios Nuevos</h5>
                        <sw-tablemultiple
                          getTable="multiple_servicios"
                          :views="[
                            { th:'Sele.', td: 'check'},
                            { th:'Servicio', td: 'name'},
                            { th:'Entidad', td: 'id_list',style: {width: '190px'}},
                            { th:'Afiliación', td: 'afiliacion'},
                            { th:'Valor', td: 'valor'},
                          ]"
                          :hideServicio="['Administración']"
                          :comparar="dataForm[namePath].servicios_activos"
                          >
                        </sw-tablemultiple>
                      </b-col>   
                      <b-col md="12">
                      </b-col>                
                    </b-row>  
                  </div>                  
                </div>
                <template  v-if="searchSw.value!=''" v-slot:footer>              
                      <sw-saveform
                      :actualizar="dataIndex[namePath]!==false"
                      :index="dataIndex[namePath]"
                      nameBtn="Afiliado"
                      @save="saveForm">
                      </sw-saveform> 
                  </template>
            </b-card>    
            <b-card  style="margin-top: 30px"  v-if="dataPost[namePath].data.length>0">
                <template v-slot:header >
                  <div class="header-card text-left">
                    Afiliados Agrupados
                  </div> 
                </template>           
                <b-row>
                      <b-col>
                        <sw-tablepost
                          :tableItems="[
                            {th: 'Documento', td: ['datos_afiliado/id_list_tipo','datos_afiliado/documento']},
                            {th: 'Nombres', td: ['datos_afiliado/nombre1','datos_afiliado/nombre2','datos_afiliado/apellido1','datos_afiliado/apellido2']},
                            {th: 'Servicios', td: ['servicios_nuevos'], tdtable: ['name']},
                          ]"
                          :tableView="['Documento','Nombres','Servicios']"
                          @save="saveForm"
                          >
                        </sw-tablepost>                       
                      </b-col>
                    </b-row>
            </b-card>       
      </b-col>      
    </b-row>  
    
    <b-modal 
      v-model="openModal.modal.value"
      :title="openModal.modal.title" 
      :header-bg-variant="'primary'"
      header-text-variant="light"
      :hide-footer="true"  
      :no-close-on-backdrop="true" 
      size="lg"  
      >        
        <sw-modalafiliacion 
          v-if="openModal.modal.modal==='Afiliacion'"
          @save="saveForm"                     
          >
        </sw-modalafiliacion>     
    </b-modal>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex"
import indexMix    from './indexMix.js'
import storeMix    from './storeMix.js'
import tableMix    from './tableMix.js'
import saveMix     from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwSearchs from '@/components/forms/searchs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwModalafiliacion  from '@/components/modals/afiliacion.vue'
import SwTablemultiple from '@/components/dataTable/tableMultiple.vue'
import SwTablepost from '@/components/dataTable/tablePost.vue'
import SwLoading from '@/components/notification/loading.vue'

export default {
  name: "afiliacion_servicios",
  components: { 
    SwSearchs,
    SwTablemultiple,
    SwSaveform,
    SwModalafiliacion,
    SwTablepost,
    SwLoading 
  },
  mixins: [indexMix, storeMix, tableMix, saveMix, saveMixins,],
};
</script>
